import React from 'react';
import {
  Landing,
  License,
  NotFound,
  PrivacyPolicy,
  Referral,
  Terms,
  TermsOfUse,
} from 'features/misc';
import { useRoutes } from 'react-router-dom';

export const AppRoutes = () => {
  const commonRoutes = [
    { path: '/', element: <Landing /> },
    { path: '/accept-terms-and-conditions', element: <Terms /> },
    { path: '/privacy-policy', element: <PrivacyPolicy /> },
    { path: '/terms-of-use', element: <TermsOfUse /> },
    { path: '/referral', element: <Referral /> },
    { path: '/license', element: <License /> },
    { path: '*', element: <NotFound /> },
  ];

  const element = useRoutes([...commonRoutes]);

  return <>{element}</>;
};
